export const iconFontAwesomeWeatherCloudBolt = (
	<i className="fa-solid fa-cloud-bolt"></i>
);
